import { IUserDetails } from "../context/types";
import { get, post } from "../utils/api";

export const fetchUser = (): Promise<IUserDetails> => {
  return get(`/users`);
};

export const createUser = (): Promise<IUserDetails> => {
  return post(`/users`);
};

export const switchToPersonalSubscription = (): Promise<IUserDetails> => {
  return post(`/users/switch-to-personal-subscription`);
};